<template>
  <div>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-xl-5 col-lg-3 col-md-3 col-sm-12 col-12 mb-5m">
          <h1 class="title-view">
            Dashboard /
            <strong class="capitalize">{{ filter | filterFormat }}</strong>
          </h1>
        </div>
        <div class="col-xl-7 col-lg-9 col-md-9 col-sm-12 col-12 alinmov5">
          <div class="box-buttons">
            <base-button
              size="sm"
              type="primary min-button"
              class="mb-p8m"
              @click="change('day')"
              :active="filter === 'day'"
              >Day</base-button
            >

            <base-button
              size="sm"
              type="primary min-button"
              class="mb-p8m"
              @click="change('week')"
              :active="filter === 'week'"
              >Week</base-button
            >

            <base-button
              size="sm"
              type="primary min-button"
              class="mb-p8m"
              @click="change('month')"
              :active="filter === 'month'"
              >Month</base-button
            >

            <base-button
              size="sm"
              type="primary min-button"
              class="mb-p8m"
              @click="change('year')"
              :active="filter === 'year'"
              >Year</base-button
            >
            <base-button
              size="sm"
              type="primary min-button"
              class="mb-p8m"
              v-on:click="filter = 'custom'"
              >Custom</base-button
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid">
      <div class="col-md-4 col-12">
        <div class="card" v-if="filter === 'custom'">
          <div class="row">
            <div
              class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 text-left align-self-center"
            >
              <base-input label="Date Range">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true, mode: 'range' }"
                  class="input-custom"
                  placeholder="Enter Date Range"
                  v-model="range"
                ></flat-picker>
              </base-input>
            </div>
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-center align-self-center"
            >
              <el-tooltip content="See range" placement="bottom">
                <base-button
                  type="primary"
                  class="btn-icon-only"
                  @click="filterCustomer"
                >
                  <i class="flaticon-visualization"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
            <stats-card
              :title="`${statsCardPrimary.passengers.label}`"
              type="gradient-info"
              :sub-title="`${statsCardPrimary.passengers.count}`"
              icon="flaticon-employees"
            >
              <template slot="footer">
                <span class="text-success mr-2">
                  <i class="flaticon-up"></i> 3.48%
                </span>
                <span class="text-nowrap">Since last month</span>
              </template>
            </stats-card>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
            <stats-card
              :title="`${statsCardPrimary.reservations.label}`"
              type="two"
              :sub-title="`${statsCardPrimary.reservations.count}`"
              icon="flaticon-contact-list"
            >
              <template slot="footer">
                <span class="text-success mr-2">
                  <i class="flaticon-up"></i> 12.18%
                </span>
                <span class="text-nowrap">Since last month</span>
              </template>
            </stats-card>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
            <stats-card
              :title="`${statsCardPrimary.clients.label}`"
              type="six"
              :sub-title="`${statsCardPrimary.clients.count}`"
              icon="flaticon-team"
            >
              <template slot="footer">
                <span class="text-danger mr-2">
                  <i class="flaticon-down"></i> 5.72%
                </span>
                <span class="text-nowrap">Since last month</span>
              </template>
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
            <stats-card
              :title="`${statsCardPrimary.cancellations.label}`"
              type="four"
              :sub-title="`${statsCardPrimary.cancellations.count}`"
              icon="flaticon-cancel"
            >
              <template slot="footer">
                <span class="text-danger mr-2">
                  <i class="flaticon-down"></i> 5.72%
                </span>
                <span class="text-nowrap">Since last month</span>
              </template>
            </stats-card>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
            <stats-card
              :title="`${statsCardPrimary.pending.label}`"
              type="five"
              :sub-title="`${statsCardPrimary.pending.count}`"
              icon="flaticon-clock"
            >
              <template slot="footer">
                <span class="text-danger mr-2">
                  <i class="flaticon-down"></i> 5.72%
                </span>
                <span class="text-nowrap">Since last month</span>
              </template>
            </stats-card>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-8 box-flex">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                <h5 class="h3 mb-0">Reservations</h5>
              </div>
            </div>
            <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="allReservationChart.chartData"
              :extra-options="allReservationChart.extraOptions"
            ></line-chart>
          </card>
        </div>

        <div class="col-xl-4 box-flex">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h5 class="h3 mb-0">Reservation Origin</h5>
              </div>
            </div>

            <pie-chart
              :height="350"
              ref="PieChart"
              :chart-data="ReservationOrigin.PieChart"
            ></pie-chart>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 col-md-6 box-flex">
          <stats-card
            :title="statsCard.branches.label"
            type="gradient-info"
            :sub-title="`${statsCard.branches.count}`"
            icon="flaticon-businessman-1"
            class="stats-perso p-card"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-md-6 box-flex">
          <stats-card
            :title="statsCard.suppliers.label"
            type="gradient-info"
            :sub-title="`${statsCard.suppliers.count}`"
            icon="flaticon-businessman-1"
            class="stats-perso p-card"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-md-6 box-flex">
          <stats-card
            :title="statsCard.companies.label"
            type="gradient-info"
            :sub-title="`${statsCard.companies.count}`"
            icon="flaticon-businessman-1"
            class="stats-perso p-card"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-md-6 box-flex">
          <stats-card
            :title="statsCard.services.label"
            type="gradient-info"
            :sub-title="`${statsCard.services.count}`"
            icon="flaticon-businessman-1"
            class="stats-perso p-card"
          ></stats-card>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-5 box-flex">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Reservations Status</h3>
              </div>
            </div>

            <div class="table-responsive table-flush p-not-action">
              <el-table
                :data="statusReservations"
                style="width: 100%"
                header-row-class-name="thead-light"
              >
                <el-table-column
                  label="Status"
                  prop="status"
                  min-width="120px"
                  class="hide-data"
                >
                  <template v-slot="{ row }">
                    <span class="font-weight-600 hide-data capitalize">{{
                      row.status
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Reservations"
                  prop="Reservations"
                  min-width="80px"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.count }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </card>
        </div>

        <div class="col-xl-7 box-flex">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Income</h3>
              </div>
            </div>
            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="incomeChart.chartData"
            ></bar-chart>
          </card>
        </div>
      </div>
      <!-- End charts-->

      <!--Lists-->

      <div class="row">
        <div class="col-xl-4 box-flex">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h5 class="h3 mb-0">Reservation Type</h5>
              </div>
            </div>

            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="typeReservation.chartData"
            ></bar-chart>
          </card>
        </div>

        <div class="col-xl-4 box-flex">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Services Type</h3>
              </div>
            </div>

            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="typeServices.chartData"
            ></bar-chart>
          </card>
        </div>

        <div class="col-xl-4">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Payment Methods</h3>
              </div>
            </div>

            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="paidMethods.chartData"
            ></bar-chart>
          </card>
        </div>

        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Top 5 Country Reservations</h3>
              </div>
            </div>

            <div class="table-responsive table-flush p-not-action">
              <el-table
                :data="countryReservations"
                style="width: 100%"
                header-row-class-name="thead-light"
              >
                <el-table-column type="expand">
                  <template v-slot="{ row }">
                    <el-table
                      class="table-responsive table"
                      :data="row.cities"
                      header-row-class-name="thead-light"
                      row-key="country"
                    >
                      <el-table-column
                        label="City"
                        prop="cities.city"
                        min-width="150px"
                      >
                        <template v-slot="{ row }">
                          <span class="font-weight-600 hide-data capitalize">{{
                            row.city
                          }}</span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="Reservations"
                        prop="Reservations"
                        min-width="80px"
                      >
                        <template v-slot="{ row }">
                          <div class="font-weight-600">{{ row.size }}</div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="progress" min-width="100px">
                        <template v-slot="{ row }">
                          <div class="text-center">
                            <span class>{{ row.progress }}%</span>
                            <base-progress
                              :type="row.type"
                              :value="row.progress"
                            />
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Countries"
                  prop="country"
                  min-width="150px"
                  class="hide-data"
                >
                  <template v-slot="{ row }">
                    <span class="font-weight-600 hide-data capitalize">{{
                      row.country
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Reservations"
                  prop="Reservations"
                  min-width="80px"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.size }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="100px" prop="progress">
                  <template v-slot="{ row }">
                    <div class="text-center">
                      <span class>{{ row.progress }}%</span>
                      <base-progress :type="row.type" :value="row.progress" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </card>
        </div>

        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                <h3 class="mb-0">Top 5 Suppliers-Destinations</h3>
              </div>
            </div>

            <div class="table-responsive table-flush p-not-action">
              <el-table
                :data="suppliersReservations"
                style="width: 100%"
                header-row-class-name="thead-light"
              >
                <el-table-column
                  label="Suppliers"
                  prop="country"
                  min-width="150px"
                  class="hide-data"
                >
                  <template v-slot="{ row }">
                    <span class="font-weight-600 capitalize">{{
                      row.name
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Reservations"
                  prop="Reservations"
                  min-width="80px"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.size }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="100px" prop="progress">
                  <template v-slot="{ row }">
                    <div class="text-center">
                      <span class="mr-2">{{ row.progress }}%</span>
                      <base-progress :type="row.type" :value="row.progress" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Charts
import moment from "moment-timezone";
import * as chartConfigs from "rhomtrip_assets/src/components/Charts/config";
import LineChart from "rhomtrip_assets/src/components/Charts/LineChart";
import BarChart from "rhomtrip_assets/src/components/Charts/BarChart";
import PieChart from "rhomtrip_assets/src/components/Charts/PieChart";

import BaseProgress from "rhomtrip_assets/src/components/BaseProgress";
import RouteBreadCrumb from "rhomtrip_assets/src/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "rhomtrip_assets/src/components/Cards/StatsCard";
import UserList from "../components/UserList.vue";
import LightTable from "../components/LightTable.vue";
import PageVisitsTable from "../components/PageVisitsTable.vue";
import { MetricsAPI } from "../../../core/api";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    BaseProgress,
    RouteBreadCrumb,
    StatsCard,
    PageVisitsTable,
    LightTable,
    UserList,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker
  },
  data() {
    return {
      allReservationChart: {
        //DATA ONLY RESERVATIONS SUCCESS
        allData: [
          [5, 30, 10, 40, 30, 15, 40, 20, 60, 10, 5], //DAY
          [5, 20, 5, 25, 10, 30, 15], //WEEK
          [30, 5, 25, 10, 30, 40, 40], //MONTH
          [30, 360, 5, 25, 10, 30, 15, 40, 40, 100, 50, 200] //YEAR
        ],

        labels: [
          [
            "02:00",
            "04:00",
            "06:00",
            "08:00",
            "10:00",
            "13:00",
            "15:00",
            "17:00",
            "19:00",
            "21:00",
            "23:00"
          ],
          ["Sun", "Mon", "Tue", "Wen", "Thu", "Fri", "Sat"],
          ["01", "05", "10", "15", "20", "25", "30"],
          [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]
        ],

        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: []
        },
        extraOptions: chartConfigs.blueChartOptions
      },

      ReservationOrigin: {
        PieChart: {
          labels: ["Web Site", "Mobility", "OTA"],
          datasets: [
            {
              label: "Reservations",
              data: [100, 80, 20],
              backgroundColor: [
                "rgba(255,178,127,.8)", // Orange
                "rgba(94,114,228,.8)", //Blue
                "rgba(45,206,137,.8)" //Green
              ]
            }
          ]
        }
      },

      typeReservation: {
        chartData: {
          labels: ["Airport", "Station", "Port", "Hourly", "Journey"],
          datasets: [
            {
              label: "Reservations",
              data: [0, 0, 0, 0, 0]
            }
          ]
        }
      },
      incomeChart: {
        chartData: {
          labels: ["US Dollar", "Euro", "British Pound", "Swiss Franc"],
          datasets: [
            {
              label: "Reservations",
              data: [100, 80, 50, 30],
              backgroundColor: [
                "rgba(133,187,101, 1)", //green
                "rgba(192,147,96, 1)", //green
                "rgba(69, 66, 90, 1)", //green
                "rgba(193,144,52,1)" //green
              ]
            }
          ]
        }
      },
      countryReservations: [
        {
          country: "United States Of America",
          size: "6480",
          progress: 0,
          type: "gradient-info",
          cities: [
            {
              city: "One",
              size: "1000"
            },
            {
              city: "Two",
              size: "1200"
            },
            {
              city: "Three",
              size: "2000"
            }
          ]
        },
        {
          country: "Venezuela (Bolivarian Republic of)",
          size: "5480",
          progress: 0,
          type: "gradient-info",
          cities: [
            {
              city: "One",
              Reservations: "1000"
            },

            {
              city: "Two",
              Reservations: "1200"
            },
            {
              city: "Three",
              Reservations: "2000"
            }
          ]
        },
        {
          country: "United Kingdom",
          size: "4807",
          progress: 0,
          type: "gradient-info"
        },
        {
          country: "Spain",
          size: "3678",
          progress: 0,
          type: "gradient-info"
        },
        {
          country: "Belgium",
          size: "2645",
          progress: 0,
          type: "gradient-info"
        }
      ],
      statusReservations: [
        {
          status: "New",
          Reservations: "20"
        },
        {
          status: "Confirmed",
          Reservations: "100"
        },
        {
          status: "Cancel",
          Reservations: "10"
        },
        {
          status: "Draft",
          Reservations: "5"
        }
      ],
      typeServices: {
        chartData: {
          labels: ["Standard", "Bussiness", "Luxury"],
          datasets: [
            {
              label: "Reservations",
              data: [100, 80, 50],
              backgroundColor: [
                "rgba(94,114,228,.8)", //Blue
                "rgba(94,114,228,.8)", //Blue
                "rgba(94,114,228,.8)" //Blue
              ]
            }
          ]
        }
      },
      paidMethods: {
        chartData: {
          labels: ["Credit Card", "OTA", "Bank Transfer"],
          datasets: [
            {
              label: "Reservations",
              data: [100, 80, 50, 30],
              backgroundColor: [
                "rgba(45,206,137,.8)", //green
                "rgba(45,206,137,.8)", //green
                "rgba(45,206,137,.8)", //green
                "rgba(45,206,137,.8)" //green
              ]
            }
          ]
        }
      },
      suppliersReservations: [
        {
          name: "Supplier 1",
          size: "6480",
          progress: 0,
          type: "gradient-info"
        },
        {
          name: "Supplier 12",
          size: "5480",
          progress: 0,
          type: "gradient-info"
        },
        {
          name: "Supplier 3",
          size: "4807",
          progress: 0,
          type: "gradient-info"
        },
        {
          name: "Supplier 8",
          size: "3678",
          progress: 0,
          type: "gradient-info"
        },
        {
          name: "Supplier 20",
          size: "2645",
          progress: 0,
          type: "gradient-info"
        }
      ],
      statsCard: {
        services: {
          label: "Services",
          count: "0"
        },
        suppliers: {
          label: "Suppliers",
          count: "0"
        },
        companies: {
          label: "Companies",
          count: "0"
        },
        branches: {
          label: "Dstinations",
          count: "0"
        }
      },
      statsCardPrimary: {
        passengers: {
          label: "passengers",
          count: "0"
        },
        reservations: {
          label: "reservations",
          count: "0"
        },
        clients: {
          label: "New Clients",
          count: "0"
        },
        growth: {
          label: "Growth",
          count: "0"
        },
        cancellations: {
          label: "Cancellations ",
          count: "0"
        },
        pending: {
          label: "To Confirm",
          count: "0"
        }
      },
      createClock: null,
      filter: "month",
      start: "",
      end: "",
      range: "",
      filtercustom: false
    };
  },
  methods: {
    filterCustomer() {
      let [start, end] = this.range.split("to");
      if (start !== "" && end !== "") {
        if (moment(start).isSameOrAfter(end)) {
          this.start = moment(end);
          this.end = moment(start);
          this.setLoad(true);
          if (this.createClock === null) {
            this.initData(this.filter);
            this.createClock = setInterval(() => {
              this.initData(this.filter);
            }, 5 * 60000);
          } else {
            clearInterval(this.createClock);
            this.initData(this.filter);
            this.createClock = setInterval(() => {
              this.initData(this.filter);
            }, 5 * 60000);
          }
        } else {
          this.start = moment(start);
          this.end = moment(end);
          this.setLoad(true);
          if (this.createClock === null) {
            this.initData(this.filter);
            this.createClock = setInterval(() => {
              this.initData(this.filter);
            }, 5 * 60000);
          } else {
            clearInterval(this.createClock);
            this.initData(this.filter);
            this.createClock = setInterval(() => {
              this.initData(this.filter);
            }, 5 * 60000);
          }
        }
      }
    },
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: "Reservations",
            data: this.allReservationChart.allData[index]
          }
        ],
        // labels[0]: ['May000', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        labels: this.allReservationChart.labels[index]
      };

      this.allReservationChart.chartData = chartData;
      this.allReservationChart.activeIndex = index;
    },
    initIncomeChart(index) {},
    getPieChar(filter) {
      MetricsAPI.GetPieChart(filter, this.start, this.end)
        .then(response => {
          let pieChart = response.data;
          this.ReservationOrigin.PieChart = Object.assign(
            {},
            pieChart.content.PieChart
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    getStatsCard(filter) {
      MetricsAPI.getStatsCard(filter, this.start, this.end)
        .then(response => {
          let statsCard = response.data;
          this.statsCard = Object.assign({}, statsCard);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getHistograms(filter) {
      MetricsAPI.getHistograms(filter, this.start, this.end)
        .then(response => {
          let data = response.data;
          //Services category
          this.typeServices.chartData = Object.assign(
            {},
            data.content.service.chartData
          );

          //Payments
          this.paidMethods.chartData = Object.assign(
            {},
            data.content.payment.chartData
          );

          //Reservation Type
          this.typeReservation.chartData = Object.assign(
            {},
            data.content.type.chartData
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    getStatusList(filter) {
      MetricsAPI.getStatusList(filter, this.start, this.end)
        .then(response => {
          let data = response.data;
          this.statusReservations = data.status;
        })
        .catch(error => {});
    },
    getStatsCardPrimary(filter) {
      MetricsAPI.getLineReservation(filter, this.start, this.end)
        .then(response => {
          let data = response.data;
          this.statsCardPrimary = Object.assign({}, data.content);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getTopsSuppliers(filter) {
      MetricsAPI.getTopsSuppliers(filter, this.start, this.end)
        .then(response => {
          let data = response.data;
          this.suppliersReservations = data.content;
        })
        .catch(() => {});
    },
    getTopsCountries(filter) {
      MetricsAPI.getTopsCountries(filter, this.start, this.end)
        .then(response => {
          let data = response.data;
          this.countryReservations = data.content;
        })
        .catch(() => {});
    },
    getIncome(filter) {
      MetricsAPI.getIncome(filter, this.start, this.end)
        .then(response => {
          this.setLoad(false);
          let chartData = response.data;
          this.incomeChart.chartData = Object.assign(
            {},
            chartData.content.chartData
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    change(filter) {
      this.filter = filter;
      this.setLoad(true);
      if (this.createClock === null) {
        this.initData(this.filter);
        this.createClock = setInterval(() => {
          this.initData(this.filter);
        }, 5 * 60000);
      } else {
        clearInterval(this.createClock);
        this.initData(this.filter);
        this.createClock = setInterval(() => {
          this.initData(this.filter);
        }, 5 * 60000);
      }
    },
    initData(filter) {
      this.getPieChar(filter);
      this.getStatsCard(filter);
      this.getHistograms(filter);
      this.getTopsSuppliers(filter);
      this.getStatusList(filter);
      this.getTopsCountries(filter);
      this.getStatsCardPrimary(filter);
      this.getIncome(filter);
    },
    ...mapMutations(["setLoad", "setItemsBread"])
  },
  watch: {
    filter: function(newValue, oldValue) {
      if (newValue !== "custom") {
        this.start = "";
        this.end = "";
      }
    }
  },
  mounted() {
    this.initBigChart(0);
    this.initIncomeChart(0);
    if (this.createClock === null) {
      this.initData(this.filter);
      this.createClock = setInterval(() => {
        this.initData(this.filter);
      }, 5 * 60000);
    }
  },
  destroyed() {
    clearInterval(this.createClock);
  },
  filters: {
    filterFormat: function(type) {
      if (type === "day") {
        return "Day";
      } else if (type === "week") {
        return "Week";
      } else if (type === "month") {
        return "Month";
      } else {
        return "Year";
      }
    }
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        active: true
      }
    ];
    this.setItemsBread(bread);
  }
};
</script>
